"use client";

import { openCookieSettings } from "@/lib/consent";

/** Öffnet das Cookie-Banner erneut (z. B. aus dem Footer). */
export function CookieSettingsButton({ className }: { className?: string }) {
  return (
    <button type="button" onClick={openCookieSettings} className={className}>
      Cookie-Einstellungen
    </button>
  );
}
